import { REGIONAL_PROD_ENVS, REGIONAL_PROD_SUBDOMAINS } from 'constants/envs';

const visitorUrl: Record<string, string> = {
  prod: 'https://visitor.alta.avigilon.com',
  dev: 'https://visitor.dev.alta.avigilon.com',
  sandbox: 'https://visitor.sandbox.alta.avigilon.com',
  mine: 'http://localhost:3000/visitor',
  test: 'https://visitor.test.alta.avigilon.com',
};

REGIONAL_PROD_ENVS.forEach((env) => {
  visitorUrl[env] =
    `https://visitor.${REGIONAL_PROD_SUBDOMAINS[env]}.alta.avigilon.com`;
});

export const getVisitorUrl = (region: OP.Env): string => {
  return `${visitorUrl[region]}`;
};
